import Bookmarks from './components/Bookmarks';

export const bookmarks = {
  firstLevel: Bookmarks,
};